module.exports = __webpack_public_path__ + "img/meating1.61c37232.jpg";